export default {
  getPlatform() {
    if (typeof Android !== 'undefined') {
      return 'android';
    } else if (typeof IOS !== 'undefined') {
      return 'ios';
    } else {
      return 'web';
    }
  },
  ios(callback) {
    if (this.getPlatform() === 'ios') {
      if (window.WKWebViewJavascriptBridge) { return callback(window.WKWebViewJavascriptBridge); }
      if (window.WKWVJBCallbacks) { return window.WKWVJBCallbacks.push(callback); }
      window.WKWVJBCallbacks = [callback];
      window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null);
    }
  },
  android(callback) {
    const { Android } = window;
    if (this.getPlatform() === 'android') {
      if (typeof Android !== 'undefined') {
        callback(Android);
      } else {
        alert('Bridge가 설정되지 않았습니다.');
      }
    }
  },
  web(callback) {
    if (this.getPlatform() === 'web') {
      callback();
    }
  },
};
